import React from 'react'
import PropTypes from 'prop-types'
import { toJS } from 'mobx'
import { observer, inject } from 'mobx-react'

@inject("store")
@observer
export default class GroupedEventBooking extends React.Component {
  static propTypes = {
    event: PropTypes.shape({
      attributes: PropTypes.array.isRequired
    }).isRequired
  }

  render() {
    const { event, store } = this.props
    const { showBrands } = store

    const {
      eventId,
      title,
      formattedStatus,
      staffMemberAbbreviations,
      brandName,
      canceled,
      postponed,
      expiredProposal
    } = event.attributes[0]

    return (
      <a href={`/events/${eventId}`} className="calendar-event">
        { event.attributes.map((a, index) =>
          <div key={index}>
            { a.formattedTimeRange } ({ a.name })
          </div>
        )}
        <div style={{fontWeight: "bold"}}>{ title }</div>
        { showBrands &&
          <div>[{ brandName }]</div>
        }
        { staffMemberAbbreviations && <div>{`(${staffMemberAbbreviations})`}</div>
        }
        <div>
          { formattedStatus }
          <em>{ expiredProposal ? " (Expired)" : "" }</em>
          <em>{ canceled ? " (Canceled)" : "" }</em>
          <em>{ postponed ? " (Postponed)" : "" }</em>
        </div>
      </a>
    )
  }
}

